module.exports = __webpack_public_path__ + "img/723.7f7020f8.jpg";